export const configClear = 'CONFIG_CLEAR';
export const configFetch = 'CONFIG_FETCH';
export const configLoaded = 'CONFIG_LOADED';
export const configError = 'CONFIG_ERROR';

export default {
    clear: configClear,
    fetch: configFetch,
    loaded: configLoaded,
    error: configError
};
